import { LitElement, html, css } from "lit";
import "@matter/matter-icon/dist/matter-icon";

class MatterFooter extends LitElement {
  static get styles() {
    return css`
      :host {
        display: block;
        font-family: Source Sans Pro, sans-serif;

        --main-hover: #0b4c1a;
        --main: #087021;
        --main-help: #c4ddca;
        --main-specific-help: #f7fbf8;
        --main-backgroung: #ffffff;

        --grey-main: #333333;
        --grey-help: #bebebe;
        --grey-container: #eeeeee;
        --grey-specific-help: #f5f5f5;

        --status-success: #2abc67;
        --status-info: #5bc0de;
        --status-warning: #f0ad4e;
        --status-error: #d9534f;

        --graph-1: #77b5c3;
        --graph-2: #4863a3;
        --graph-3: #9371ac;
        --graph-4: #d87d7d;
        --graph-5: #d9a46c;
        --graph-6: #e3cd66;

        --theme: #ffffff;
        --gray: #333333;
      }
      :host * {
        outline: 0;
      }

      matter-footer:focus, matter-icon:focus{
        outline: 0 !important;
      }

      :host a {
        text-decoration: none;
        font-size: 14px;
      }

      :host a2 {
        text-decoration: none;
        font-size: 14px;
        cursor: pointer;
      }

      :host a:hover {
        text-decoration: underline;
      }

      :host a2:hover {
        text-decoration: underline;
      }

      .footer {
        background: rgb(231, 231, 231);
      }

      :host .footer-top a {
        max-width: 100%;
      }
      :host .footer-bottom a {
        max-width: 100%;
      }

      :host h1 {
        font-family: "Source Sans Pro", sans-serif;
        font-size: 22px;
        font-weight: 700;
        line-height: 30px;
        margin: 0 0 1rem;
      }

      :host ul {
        padding: 0px;
        margin: 0px 0px;
      }

      :host u2 {
        flex-wrap: wrap;
        max-width: 260px;
        display: flex;
      }

      :host li {
        margin-bottom: 15px;
        list-style-type: none;
      }

      :host li2 {
        list-style-type: none;
        display: inline-flex;
        width: 50px;
      }

      :host .container.footer-top {
        background: var(--gray);
        max-width: 100%;
        overflow: overlay;
        padding-top: 30px !important;
      }
      :host .container.footer-bottom {
        background: #e7e7e7;
        max-width: 100%;
      }
      :host .container {
        position: relative;
        margin-right: auto;
        margin-left: auto;
        width: 100%;
        box-sizing: border-box;
      }

      .logosFooter {
        margin: 0 20px 0 0;
      }

      .textoSubSecciones {
        font-family: "Source Sans Pro", sans-serif;
        color: var(--theme);
        font-size: 15px !important;
        line-height: 20px !important;
        font-weight: 400 !important;
      }

      :host .row {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
      }

      :host .column {
        display: flex;
        flex-direction: column;
        flex-basis: 100%;
        flex: 1;
      }

      .imageColumn {
        max-width: 115px;
        image-rendering: -webkit-optimize-contrast;
      }

      /**
     * Partes del footer
     */
      :host footer {
        padding: 0;
      }

      .container1 {
        padding: 30px 0 40px;
      }

      .container2 {
        padding: 0px 15px;
      }

      .container3 {
        display: flex;
        flex-flow: nowrap;
        max-width: 100%;
        align-items: center;
      }

      :host footer .container .row {
        margin: 0 auto;
        max-width: 1275px;
      }

      :host footer .container .row:not(:last-child) {
        border: none;
      }

      :host footer .column {
        border: none;
      }

      :host .links,
      :host .social {
        align-items: center;
      }

      :host .links {
        margin-left: auto;
        display: flex;
        justify-content: flex-end;
        flex: 1 0 0%;
        width: 0px;
        margin-top: 1rem;
      }

      :host .links a {
        margin-right: 22px;
        margin-left: 22px;
        line-height: 1.5;
        font-family: "Source Sans Pro";
        font-size: 15px;
        font-weight: 400;
        color: #333;
        text-align: center;
      }

      :host .links a:hover {
        text-decoration: underline;
        color: #0b4c1a;
      }

      :host .social a {
        text-decoration: none;
      }
      :host .social a2 {
        text-decoration: none;
      }

      :host .social a2:not(:last-child) {
        margin-right: 25px;
      }

      :host .footer-logo {
        display: inline-block;
        background-repeat: no-repeat;
        background-position: left center;
        max-width: 100%;
        padding: 0.5rem 0;
      }

      .columna {
        flex: 0 0 25%;
        max-width: 25%;
      }

      /**
     * Responsividad
     */

      .zoom {
        transition: transform 0.2s; /* Animation */
        cursor: pointer;
      }

      .zoom:hover {
        transform: scale(
          1.15
        ); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
      }

      :host hr {
        visibility: hidden;
        border: 1;
      }

      .hr {
        border: 1;
      }

      .flex-container {
        display: flex;
        flex-wrap: wrap;
      }

      .flex-container > div {
        width: 100px;
        margin: 10px;
        text-align: center;
        line-height: 75px;
        font-size: 30px;
      }

      .widthColumns {
        padding: 0px 15px 0px 15px;
        margin-bottom: 40px;
      }

      @media (max-width: 1300px) {
        .responsiveColumns {
          max-width: 960px !important;
        }

        .columna {
          flex: 0 0 25%;
          max-width: 25%;
        }
      }

      @media (max-width: 992px) {
        .responsiveColumns {
          max-width: 720px !important;
        }

        .columna {
          flex: 0 0 50%;
          max-width: 50%;
        }

        .displayDownFooter {
          display: flex;
          flex-direction: column !important;
        }

        :host .links {
          margin-left: 0px;
          width: 100%;
          min-height: 54px;
          margin: 16px 0px 8px 0px;
          align-self: center;
          justify-content: center;
        }

        :host .links a {
          margin: auto;
        }

        .footer-logo {
          height: 70px;
          width: auto;
        }

        .logosFooter {
          margin: auto;
          padding: 0.5rem 0px;
        }

        .container3 {
          display: flex;
          flex-flow: nowrap;
          justify-content: center;
          width: 100%;
          align-items: center;
        }
      }

      @media (max-width: 768px) {
        .responsiveColumns {
          max-width: 540px !important;
        }

        .footer-logo {
          height: 60px;
        }

        .columna {
          flex: 0 0 50%;
          max-width: 50%;
        }
      }

      @media (max-width: 576px) {
        .responsiveColumns {
          max-width: 540px !important;
          margin-bottom: 20px !important;
        }

        :host .links,
        :host .social {
          align-items: center;
          padding: 24px 0px;
        }

        .widthColumns {
          margin-bottom: 20px;
        }

        .container3 {
          flex-flow: wrap;
        }

        :host .links a {
          margin: auto;
          display: block;
          padding: 11px 0px;
          font-size: 15px;
          font-weight: 400;
        }

        .columna {
          flex: 0 0 100%;
          max-width: 100%;
        }

        :host .social {
          margin-top: 0px;
          margin-bottom: 0px;
          margin-left: 0px;
          flex-basis: 100%;
        }

        :host .links {
          flex-basis: 100%;
          margin: 0px 0 0;
          display: flex;
          flex-direction: column;
          font-size: 18px;
          -ms-flex-direction: column;
          justify-items: center;
          justify-content: center;
        }

        .centerLogos {
          justify-content: center !important;
        }
      }
    `;
  }

  static get properties() {
    return {
      brandLogo: { type: Boolean },
      brandSrc: { type: String },
      brandName: { type: String },
      brandCaption: { type: String },
      data: { type: String },

      _response: { type: Object },
    };
  }

  constructor() {
    super();
    this.brandLogo = false;
    this.brandSrc = "";
    this.brandName = "";
    this.brandCaption = "";

    this._response = {
      columns: [],
      links: [],
      social: [],
      logos: [],
    };
  }

  render() {
    return html`
      <footer class="footer">
        <div style="background: #333333">
          <div class="container footer-top">
            <div class="row site-footer__top responsiveColumns">
              ${this.ocultarSecciones === "false"
                ? html`
                    ${this._response.columns.map(
                      (column, index) => html`
                        <div class="columna">
                          ${column.columna.map(
                            (column2) => html`
                              <div class="column widthColumns">
                                <h1 tabindex="0" style="color: white;">${column2.title}</h1>
                                <ul>
                                  ${column2.array.map(
                                    (link) => html`
                                      <li>
                                        <a
                                          class="textoSubSecciones"
                                          target="_top"
                                          href="${link.href}"
                                          title="${link.title}"
                                          >${link.title}</a
                                        >
                                      </li>
                                    `
                                  )}
                                </ul>
                              </div>
                            `
                          )}
                          ${this.ocultarSeccionSocial === "false"
                            ? html`
                                ${this._response.columns.length - 1 === index
                                  ? html`
                                      <div class="column widthColumns">
                                        ${this._response.social.map(
                                          (social) => html`
                                            <div>
                                              <h1 tabindex="0" style="color: white;">
                                                ${social.title}
                                              </h1>
                                              <u2>
                                                ${social.array.map(
                                                  (socialAux) => html`
                                                    <li2
                                                      style="width: auto !important;"
                                                    >
                                                      ${socialAux.image !==
                                                        "" &&
                                                      socialAux.icon === ""
                                                        ? html` <a
                                                            href="${socialAux.href}"
                                                            ><img
                                                              src="${socialAux.image}"
                                                              alt="${socialAux.alt}"
                                                              title="${socialAux.title}"
                                                              class="imageColumn"
                                                              style="display:none;"
                                                              onload="this.style.display='flex'"
                                                          /></a>`
                                                        : html``}
                                                      ${socialAux.image ===
                                                        "" &&
                                                      socialAux.icon !== ""
                                                        ? html` <a alt="${socialAux.alt}"
                                                            href="${socialAux.href}"
                                                            ><matter-icon
                                                              aria-label=${socialAux.icon}
                                                              icon=${socialAux.icon}
                                                              title="${socialAux.title}"
                                                              style="width: 50px"
                                                              color="#ffffff"
                                                              family="fab"
                                                              size="lg"
                                                            ></matter-icon
                                                          ></a>`
                                                        : html``}
                                                    </li2>
                                                  `
                                                )}
                                              </u2>
                                            </div>
                                          `
                                        )}
                                      </div>
                                    `
                                  : html``}
                              `
                            : html``}
                        </div>
                      `
                    )}
                  `
                : html``}
            </div>
          </div>
        </div>

        <div style="background: #e7e7e7">
          <div class="container footer-bottom responsiveColumns container1">
            <div class="row site-footer__bottom justContCenter centerLogos displayDownFooter container2">
              <div class="container3">
                ${this._response.logos.map(
                  (logos) => html`${(logos.href === undefined || logos.href === "") ?
                  html`
                    <a class="logosFooter"
                      ><img src="${logos.image}" alt="${logos.alt}" class="footer-logo"
                    /></a>
                  `:html`
                    <a class="logosFooter" href="${logos.href}"
                      ><img src="${logos.image}" alt="${logos.alt}" class="footer-logo"
                    /></a>
                  `}`
                )}
              </div>
              <div class="links flex-container">
                ${this._response.links.map(
                  (link) => html`
                    <a
                      class="textResponsiveFooter"
                      href=${link.href}
                      title=${link.title}
                      >${link.title}</a
                    >
                  `
                )}
              </div>
            </div>
          </div>
        </div>
      </footer>
    `;
  }
  addFont() {
    const sourceSans = document.createElement("link");
    sourceSans.href =
      "https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@300;400;600;700&display=swap";
    sourceSans.rel = "stylesheet";
    document.head.append(sourceSans);
  }

  firstUpdated() {
    this.addFont();
    const notosans = document.createElement("link");
    notosans.href =
      "https://fonts.googleapis.com/css2?family=Noto+Sans+TC&display=swap";
    notosans.rel = "stylesheet";
    document.head.appendChild(notosans);
  }

  updated(changedProperties) {
    changedProperties.forEach((_, propName) => {
      if (
        ["brandLogo", "brandSrc", "brandName", "brandCaption", "data"].includes(
          propName
        )
      ) {
        this.updatedResponse();
      }
    });
  }

  updatedResponse() {
    try {
      this.jsonSecciones = JSON.parse(this.data);
      this._response = this.jsonSecciones;
    } catch (e) {
      //Controlate parse error for fetch
      if (this.data) {
        this.loadTreeMapData();
      }
    }
  }

  async loadTreeMapData() {
    await fetch(this.data).then(response => response.json()).then(data => {
      this._response = data;
    }).catch(error => "");
  }

  get ocultarSecciones() {
    return this.getAttribute("ocultarSecciones");
  }

  set ocultarSecciones(newValue) {
    this.setAttribute(
      "ocultarSecciones",
      this.getAttribute("ocultarSecciones")
    );
  }

  get ocultarSeccionDisponible() {
    return this.getAttribute("ocultarSeccionDisponible");
  }

  set ocultarSeccionDisponible(newValue) {
    this.setAttribute(
      "ocultarSeccionDisponible",
      this.getAttribute("ocultarSeccionDisponible")
    );
  }

  get ocultarSeccionSocial() {
    return this.getAttribute("ocultarSeccionSocial");
  }

  set ocultarSeccionSocial(newValue) {
    this.setAttribute(
      "ocultarSeccionSocial",
      this.getAttribute("ocultarSeccionSocial")
    );
  }
}

if (!window.customElements.get("matter-footer")) {
  window.customElements.define("matter-footer", MatterFooter);
}
